import { Button, Input } from "antd";
import React, { useEffect, useState } from "react";
import "./search-home-filter.css";
import SearchFilterDate from "./search-filter-date";
import dayjs from "dayjs";
import { serverFetch } from "@src/server";
import { GuestsControl } from "@src/controls";
import { useNavigate  } from 'react-router-dom';
import { useWindowWidth } from "@react-hook/window-size";
import { withoutTime } from "@src/extensions/utils";
import LocalFuncs from "@src/extensions/local-funcs";
import { useSelector } from "react-redux";
import { useAppDispatch } from "@src/store/hooks";
import { categoryFilterChanged } from "@src/store/actions";
import SearchHomeBlock from "./search-home-block";

const SearchHomeFilter = () => {
    const d = useAppDispatch();
    const [searchedItems, setSearchedItems] = useState([]);
    const [showSearched, setShowSearched] = useState(false);
    const [selectingItems, setSelectingItems] = useState(false);
    const [openPopover, setOpenPopover] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedItem, setSelectedItem] = useState();
    const [filter, setFilter] = useState(LocalFuncs.checkFilterPeriod(useSelector((s) => s.reservationRoomFilter))); // Получить скорректированный сохраненный фильтр
    const navigate = useNavigate ();
    const isMobile = useWindowWidth() <= 992;

    // Проверка параметров URL для подстановки в фильтр
    const checkSearchParams = (filter_) => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("setParams")) {
            const newFilter = {...filter_};
            const url = new URL(window.location.href);
            url.searchParams.delete("setParams");
            if (urlParams.get("arrivalDate")){
                newFilter.arrivalDate = dayjs(urlParams.get("arrivalDate"));
                url.searchParams.delete("arrivalDate");
            }
            if (urlParams.get("departureDate")){
                newFilter.departureDate = dayjs(urlParams.get("departureDate"));
                url.searchParams.delete("departureDate");
            }
            if (urlParams.get("adultsQty")){
                newFilter.adultsQty = Number(urlParams.get("adultsQty"));
                url.searchParams.delete("adultsQty");
            }
            if (urlParams.get("childAges")){
                const childAges = urlParams.get("childAges")?.split(",").map(Number);
                newFilter.childAges = childAges || [];
                newFilter.childsQty = childAges?.length ?? 0; 
                url.searchParams.delete("childAges");
            }
            else {
                newFilter.childAges = [];
            }
            const filter2 = LocalFuncs.checkFilterPeriod(newFilter);
            setFilter(filter2);
            d(categoryFilterChanged(filter2));            
            navigate(url, { replace: true });
        }
    }	

    useEffect(() => checkSearchParams(filter), []);

    const onSelectRegion = (value) => {
        switch (value.idx) {
            case 1:
                navigate(`/booking/search/region/${value.url}?place=${value.placeId}`);
                break;
            case 2:
                navigate(`/booking/search/region/${value.url}`);
                break;
            case 3:
                navigate(`/booking/search/category/${value.companyId}`);
                break;
            default:
                break;
        }

        // if (value.idx === 2)
        // setSelectedItem(value);
        // if (value) {
        //     setSearchText(value.regionName);
        //     setFilter({...filter, regionCode: value.url})
        // }
        // setSelectingItems(false);
    }
    const onSearch = (e) => {
        setSelectedItem(null);
        const value = e ? e.target.value : "";
        setSearchText(value);
        serverFetch(`companies/search?text=${value}`)
            .then(data => setSearchedItems(data))
            .catch(ex => console.log('Ошибка получения списка', ex));
    }
    useEffect(onSearch, []);

    const regionItems = searchedItems.filter(i => i.idx === 1 || i.idx === 2);
    const companyItems = searchedItems.filter(i => i.idx === 3);

    const divSearchedItems = [];
    if (regionItems.length > 0) {
        divSearchedItems.push(<div key="1" className="search-home-filter-searched-item-title">МЕСТА и РЕГИОНЫ</div>)
        divSearchedItems.push(...regionItems.map(item => <div key={`${item.placeId}-${item.regionId}-${item.companyId}`} className="search-home-filter-searched-item" 
            onClick={() => onSelectRegion(item)} dangerouslySetInnerHTML={{ __html: item.text }}/>))
    }

    if (companyItems.length > 0) {
        divSearchedItems.push(<div key="3" className="search-home-filter-searched-item-title">ТУРКОМПЛЕКСЫ</div>)
        divSearchedItems.push(...companyItems.map(item => <div key={`${item.placeId}-${item.regionId}-${item.companyId}`} className="search-home-filter-searched-item" 
            onClick={() => onSelectRegion(item)} dangerouslySetInnerHTML={{ __html: item.text }}/>))
    }

    const divSearched = (showSearched || selectingItems) && <div className="search-home-filter-searched-items" 
        onMouseEnter={() => setSelectingItems(true)}
        onMouseLeave={() => setSelectingItems(false)}>
        {divSearchedItems}
    </div>
    const disabledDate = (current) => current && dayjs(current) < withoutTime(dayjs())
    const disabledDateEnd = (current) => current && (dayjs(current) < withoutTime(dayjs()) || current < filter.arrivalDate)
    const onChangeDateBeg = (arrivalDate) => {
        const srok = filter.departureDate.diff(filter.arrivalDate, 'days');
        const departureDate = arrivalDate.add(srok, 'days');
        setFilter({...filter, arrivalDate, departureDate})
    }
    const onChangeDateEnd = (departureDate) => setFilter({...filter, departureDate})

    const onGo = () => {
        d(categoryFilterChanged(filter))
        navigate(`/booking/search/region/${selectedItem?.urlName}`)
    }
    return  <>
        <div className="search-home-filter">
            <div className="search-home-filter-title">Путешествуйте по России с нами</div>
            <div className="search-home-filter-body">
                <div className="search-home-filter-segment">
                    <img src="/images/search.svg" alt="pic" />
                    <Input placeholder="Введите название региона" className="search-home-input" 
                        onFocus={() => setShowSearched(true)}
                        onBlur={(e) => setShowSearched(false)}
                        value={searchText}
                        onChange={onSearch}
                    />
                </div>
                {divSearched}
                <div className="search-home-filter-segment">
                    <SearchFilterDate title="ЗАЕЗД" value={filter.arrivalDate} onChange={onChangeDateBeg} disabledDate={disabledDate}/>
                    <SearchFilterDate title="ВЫЕЗД" value={filter.departureDate} onChange={onChangeDateEnd} disabledDate={disabledDateEnd}/>
                </div>
                <div className="search-home-filter-segment">
                    <GuestsControl filter={filter} setFilter={setFilter} openPopover={openPopover} handleOpenPopoverChange={setOpenPopover}/>
                </div>
                {isMobile ? <div className="search-home-filter-segment">
                      <Button className="search-home-button" disabled={!selectedItem} onClick={onGo}>Найти</Button></div> 
                    : <Button className="search-home-button" disabled={!selectedItem} onClick={onGo}>Найти</Button>}                
            </div>
        </div>
        <div className="search-home-text">
        Сервис КУПИТЬ ПУТЁВКУ предлагает отдых и лечение на лучших курортах. 
        Бронирование отелей, гостиниц, санаториев и баз отдыха онлайн с гарантированным размещением и по официальным ценам всегда доступны 
        на нашем сайте <a href="https://rr-tour.ru">rr-tour.ru</a>. 
        Мы занимаемся автоматизацией онлайн бронирования с 2012 года!
        </div>
        {!isMobile && <img src="/images/main-splash.png" style={{marginTop: 32}} alt="main"/>}
        <div className="search-home-title">СТАНЬТЕ ПАРТНЁРОМ СЕРВИСА КУПИТЬ ПУТЁВКУ</div>
        <div className="search-home-blocks">
            <SearchHomeBlock title="Добавьте свой объект размещения" text="Получайте больше бронирований от туристов на вашем сайте, в сообществе, в поиске по региону"
                img="/images/247.png"
                link={`/article/${encodeURIComponent(process.env.REACT_APP_MAIN_ARTICLE)}`} />
            <SearchHomeBlock title="Откройте онлайн продажи на вашем сайте и в сообществе" 
                text="Установите модуль бронирования КУПИТЬ ПУТЁВКУ на выгодных условиях"
                img="/images/direct.png"
                link="https://modul.rr-tour.ru/"/>
        </div>
    </>
}

export default SearchHomeFilter;